/* eslint-disable eqeqeq */
import React, { createRef, useContext, useRef, useState } from "react";
import { Col, Form, Row, Button } from "react-bootstrap";
import { FaFilePdf } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Loader from "../Loader/Loader";
import { PDFDownloadLink } from '@react-pdf/renderer';
import ProposalFormat from '../../component/PDF/proposalFormat';

// import { AuthContext } from "../../contexts/AuthProvider";
// import "./Result.css";
import { toast   } from "react-hot-toast";
import Pdf from "react-to-pdf";
import { axiosOpen } from "../../api/axios";
const ref = createRef();
// const Result = ({ clientName,proposalLetter,questions }) => async () => {
  
  let tempArray = [];
const Result = (props) =>  {
  const dataForPdf = useRef({});
  const navigate = useNavigate();
  const [newStyle, setNewStyle] = useState({});
  const [overlay, setOverlay] = useState({});
  const [loading, setLoading] = useState(false);
  const [isApiCallComplete, setIsApiCallComplete] = useState(false);

  const user = JSON.stringify({
    email : props.user.email,
})
const body = JSON.stringify({
    // _id:"6411a34944faa3ecd3efdfcb",
     propId:props.propId,
    answer:props.questions.map(
      (data) => {
        return {
          question:data.question,
          answer:data.answer
        }
      }
    ),
    proposal:props.proposalLetter,
})
const data = JSON.stringify({
  // proposalId:"6419669bc6ffeafaf5867845",
  proposalId:props.propId,
});
function saveData() {
     axiosOpen
    .put("/api/bd/SaveProposal",body)
    .then((res) => {
      console.log("res is", res);
      setIsApiCallComplete(true);
      toast.success('Data saved!');

    })
    .catch((err) => {
      console.log(err);
      toast.error('Somthing went wrong!');
    });
}
function disCard(){
  axiosOpen
    .put("api/bd/setdeletestatus",data)
    .then((res) => {
      console.log("res ", res);
      toast.success('Deleted Successfully!')
    })
    .catch((err) => {
      console.log(err);
      toast.error('Somthing went wrong!');
    });
}
const firstLine = 'Dear ' + props.clientName + ',';
var cont = true;
console.log('hi',props.proposalLetter);
if (props.proposalLetter !== 'Exhausted 10 Free trials for the day') {  
  var propLetter = props.proposalLetter.split("\n");
  console.log('array is',propLetter)
  const letterLength = propLetter.length;
  propLetter[letterLength - 1] = props.user.fname+' '+props.user.lname;
  dataForPdf.current={...dataForPdf.current,proposalLetter:propLetter}
  const handleStyle = () => {
    setLoading(true);
    setNewStyle({
      width: '70vw'
    });
  
    setTimeout(() => {
      setNewStyle({}); // remove style after 1 second
      setLoading(false);
    }, 500);
  };
  const handleOverlay = () => {
    setOverlay({
      backgroundColor: 'rgba(0,0,0,0.9)',
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      zIndex: 1,
      fontSize: '4rem',
      display:'flex',
      justifyContent:'center',
      alignItems:'center',
      color:'white',
    });
    setTimeout(() => {
      setOverlay({}); // remove style after 1 second
    }, 3000);
  };
  return (
    <>
      <Row>
        <Col md={10} >
          {loading&&<div style={{...overlay}}>Pdf Generating</div>}
          <Form className="my-3 bg-form pb-3 shadow mb-3 rounded" style={{overflowX:'hidden'}}>
            <div ref={ref} style={{ height: 'auto',...newStyle }}>
              <div className="mb-4 p-4">
                <h3 className="img-fluid"><b>PROPOSAL</b></h3>
                <div>
                  {propLetter.map((data, index) => {
                    console.log(data);
                    if(props.clientName && data.match("Dear")){
                      dataForPdf.current = {...dataForPdf.current,proposalFirstName:firstLine}
                      {console.log('index is ',index)}
                      return(
                        <span key={index}>{firstLine}<br/></span>
                      )
                    }
                    else if(user && (data.match("Your Name") || data.match("Your name") ) ){
                      {console.log('index is ',index)}
                      cont = false;
                      dataForPdf.current = {...dataForPdf.current,proposalSentBy:`${props.user.fname} ${props.user.lname}`}
                      return(
                        <span key={index}>{props.user.fname+" "+props.user.lname}<br/></span>
                      )
                    }
                    else if(cont){
                      console.log('data is',data);
                      tempArray.push(data);
                      dataForPdf.current = {...dataForPdf.current,proposal:tempArray}
                                             
                      return(
                        <>
                          <span key={index}>{data}<br/></span> 
                        </>
                                                 
                      )
                    }
                    else{
                      return false;
                    }
                  })    
                  }
                  </div>
                 
                  <>
                            <br/>
                            {props.questions.length > 0 ?(<> <div style={{fontWeight:"bold"}}>Questions : </div>
                            
                            <div>
                              
                            {
                             
                              props.questions.map((data,index)=>{
                                return (
                                  <>
                                    <div>
                                      {
                                        index+1
                                      }
                                      . 
                                      {
                                        data.question
                                      }
                                    </div>
                                    <div> Answer : 
                                      {
                                        data.answer
                                      }
                                    </div>
                                    <br/>
                                  </>
                                )
                              })
                            }
                            </div>
                            
                             </>): null}
                            
                          </>
              </div>
            </div>
         <Button variant="primary" className="ms-4" onClick={()=> {saveData() && props.newRequest()}} disabled={isApiCallComplete} >{isApiCallComplete ? 'Saved' : 'save'}</Button>
            <Button variant="secondary" className="ms-4" onClick={() =>{disCard() || props.newRequest() }} disabled={isApiCallComplete}>Discard</Button>
            <Pdf targetRef={ref} filename="Proposal.pdf" x={.5} y={.5} scale={0.8}>
              {({ toPdf }) => <Button variant="primary" className="ms-4" onClick={()=>{handleStyle(); toPdf(); handleOverlay();}}><FaFilePdf /> Download Pdf </Button>}
            </Pdf>
            <Button variant="success" className="ms-4" onClick={() => props.newRequest()}> New Request </Button>
            <Button variant="success" className="ms-4" onClick={() => props.regenrate(props.data)}> Regenerate Response</Button>
          </Form>
        </Col>
      </Row>

    </>
  )}
else {
  return (
    <>
      <Row>
        <Col md={7} >
          <Form className="my-3 bg-form pb-3 shadow mb-3 rounded">
            <div ref={ref} style={{ height: 'auto' }}>
              <div className="mb-4 p-4">
                <h5 className="img-fluid"><center>Exhausted 10 Free trials for the day</center></h5>
              </div>
            </div>
          </Form>
        </Col>
      </Row>

    </>
  );
}


};

export default Result;
